import { useEffect } from 'react';

import { useSelector } from 'react-redux';

import type { CommonReduxState } from '@src/models/commons/reduxState.interface';

import { useHistory, useLocation } from 'react-router-dom';

import { type ReportUrlState, serializeReportUrlFilters } from '../utils/reportUrl';

export const useSyncReportUrl = (filters: ReportUrlState, entity: 'schedules' | 'templates' | 'routes' | 'operations', divisions: string[]) => {
  const history = useHistory();
  const location = useLocation();
  const assigned = useSelector((state: CommonReduxState) => state.divisions?.assigned?.data?.divisions);
  const allowedIds = Object.values(assigned ?? {}).map(division => division.id);
  const search = serializeReportUrlFilters(location.search, filters, entity, divisions, allowedIds);
  useEffect(() => {
    if (location.search !== search) history.replace({ ...location, search });
  }, [history, location, search]);
};
